import * as React from "react"
import Layout from "../components/layout/layout";
import SubPageTitle from "../components/common/sub-page-title";
import CallToAction from "../components/common/call-to-action";
import * as priceStyle from "./cennik.module.scss";
import Seo from "../data/seo"

const PricingPage = () => {
    return (
        <Layout seo={Seo.cennik}>
            <SubPageTitle title="Cennik"></SubPageTitle>
            <div className="container">
                <div className="row justify-content-center">
                    <div>

                        <h4 className="pb-2 mb-3 bb-primary d-inline-block">Podologia</h4>
                        <table className={priceStyle.priceTable + " table table-striped"}>
                            <tbody>
                            <tr>
                                <td>Konsultacja (darmowa podczas zabiegu)</td>
                                <td>100 zł</td>
                            </tr>
                            <tr>
                                <td>Podstawowy zabieg podologiczny</td>
                                <td>190 zł</td>
                            </tr>
                            <tr>
                                <td>Rozszerzony zabieg podologiczny</td>
                                <td>250 zł</td>
                            </tr>
                            <tr>
                                <td>Podstawowy pedicure KART</td>
                                <td>240 zł</td>
                            </tr>
                            <tr>
                                <td>Rozszerzony pedicure KART</td>
                                <td>290 zł</td>
                            </tr>
                            <tr>
                                <td>Obcięcie i opracowanie paznokci zdrowych</td>
                                <td>130 zł</td>
                            </tr>
                            <tr>
                                <td>Opracowanie płytki paznokciowej zmienionej chorobowo</td>
                                <td>150 zł + 20 zł każdy kolejny</td>
                            </tr>
                            <tr>
                                <td>Opracowanie pękających pięt</td>
                                <td>160 zł</td>
                            </tr>
                            <tr>
                                <td>Opracowanie hiperkeratozy</td>
                                <td>160 zł</td>
                            </tr>
                            <tr>
                                <td>Usuwanie odcisków/modzeli</td>
                                <td>130 zł + 20 zł każdy kolejny</td>
                            </tr>
                            <tr>
                                <td>Usuwanie brodawek wirusowych (kurzajek)</td>
                                <td>100-200 zł</td>
                            </tr>
                            <tr>
                                <td>Opracowanie wrastającego paznokcia</td>
                                <td>160 zł - jeden palec</td>
                            </tr>
                            <tr>
                                <td>Założenie klamry ortonyksyjnej</td>
                                <td>200 zł</td>
                            </tr>
                            <tr>
                                <td>Przesunięcie klamry</td>
                                <td>150 zł</td>
                            </tr>
                            <tr>
                                <td>Kontrola klamry/zakończenie terapii</td>
                                <td>80 zł</td>
                            </tr>
                            <tr>
                                <td>Tamponada</td>
                                <td>30 zł</td>
                            </tr>
                            <tr>
                                <td>Usunięcie krwiaka podpaznokciowego</td>
                                <td>150 zł</td>
                            </tr>
                            <tr>
                                <td>Rekonstrukcja paznokcia</td>
                                <td>150 zł</td>
                            </tr>
                            <tr>
                                <td>Opatrunek z odciążeniem</td>
                                <td>70 zł</td>
                            </tr>
                            <tr>
                                <td>Okluzja</td>
                                <td>30 zł</td>
                            </tr>
                            <tr>
                                <td>Badanie mykologiczne/mikrobiologiczne</td>
                                <td>150 zł</td>
                            </tr>
                            <tr>
                                <td>Ortoza indywidualna</td>
                                <td>100 zł</td>
                            </tr>
                            <tr>
                                <td>Kinesiotaping</td>
                                <td>20-50 zł</td>
                            </tr>
                            <tr>
                                <td>Zdjęcie hybrydy</td>
                                <td>50 zł</td>
                            </tr>
                            <tr>
                                <td>Dezynfekcja obuwia KLENZ - 1 para</td>
                                <td>20 zł</td>
                            </tr>
                            <tr>
                                <td>Dezynfekcja obuwia KLENZ - 3 pary</td>
                                <td>50 zł</td>
                            </tr>
                            </tbody>
                        </table>

                        <h4 className="pb-2 mb-3 bb-primary d-inline-block">Refleksologia</h4>
                        <table className={priceStyle.priceTable + " table table-striped"}>
                            <tbody>
                            <tr>
                                <td>Refleksologia stóp</td>
                                <td>160 zł</td>
                            </tr>
                            <tr>
                                <td>Refleksologia rąk</td>
                                <td>160 zł</td>
                            </tr>
                            <tr>
                                <td>Refleksologia twarzy</td>
                                <td>200 zł</td>
                            </tr>
                            </tbody>
                        </table>
                        <p className="py-4 text-center">Cennik ma charakter orientacyjny i nie stanowi oferty w rozumieniu Kodeksu Cywilnego.</p>
                    </div>
                </div>
            </div>
            <CallToAction text=""></CallToAction>
        </Layout>
    )
}

export default PricingPage